<ng-container *ngIf="isVisible">
  <div class="mx-2 mt-2 pb-3 session-panel-container">
    <div class="d-flex justify-content-between">
      <h3>Session Catalog</h3>
      <button
        nf-icon-button="secondary"
        icon="close"
        class="btn-bare close"
        ngbTooltip="Close Session Catalog"
        (click)="closePanel.emit()"
      >
        Close Session Catalog
      </button>
    </div>
    <div class="panel-section">
      <div
        [ngbTooltip]="
          sessionsAtMax
            ? 'Close an open session above to create a new session.'
            : null
        "
      >
        <button
          nf-button="primary"
          [disabled]="sessionsAtMax"
          id="create-new-session-button"
          (click)="toggleCreateNewSessionModal()"
          [loading]="isLoadingSessions"
          [disableLoadingComplete]="disableLoadingSessionsComplete"
        >
          Create New Session
        </button>
      </div>
      <h5 class="disable-selection">
        Pinned Sessions
        <span
          class="mdi mdi-information"
          [ngbTooltip]="
            'You are allowed ' +
            maxPinnedSessionsAllowed +
            ' pinned sessions and ' +
            maxAllowedSessions +
            ' open sessions.'
          "
        ></span>
      </h5>
      <hs-session-card
        *ngFor="let session of pinnedSessions"
        [session]="session"
        [isActive]="activeSessionId === session.id"
        [isMaxedPinnedSessionsReached]="
          pinnedSessions.length >= maxPinnedSessionsAllowed
        "
        (contentDoubleClicked)="makeSessionActive(session)"
        (expanded)="expandedCards[session.id] = $event"
      >
        <div class="session-drawer-buttons">
          <button
            nf-icon-button="secondary"
            icon="close"
            class="btn-bare close"
            ngbTooltip="Close Session"
            (click)="deleteSession(session.id)"
            [loading]="deleteLoading && session.id === deleteSessionId"
          >
            Close Session
          </button>
          <button
            nf-icon-button="secondary"
            [icon]="session.isAffectedByJobRun ? 'reload-alert' : 'reload'"
            class="btn-bare reload"
            [ngClass]="{ 'text-danger': session.isAffectedByJobRun }"
            ngbTooltip="Refresh Session"
            [loading]="isRefreshingSession"
            (click)="refreshSession(session)"
            [disabled]="session.loadedAccountIds.length === 0"
            *ngIf="activeSessionId === session.id || expandedCards[session.id]"
          >
            Refresh Session
          </button>
        </div>
      </hs-session-card>
      <div
        *ngIf="pinnedSessions.length >= maxPinnedSessionsAllowed"
        class="small ml-1"
      >
        *You have reached the limit amount for pinned sessions.
      </div>
      <h5 class="disable-selection">Unpinned Sessions</h5>
      <hs-session-card
        *ngFor="let session of unpinnedSessions"
        [session]="session"
        [isActive]="activeSessionId === session.id"
        (contentDoubleClicked)="makeSessionActive(session)"
        (expanded)="expandedCards[session.id] = $event"
        [isMaxedPinnedSessionsReached]="
          pinnedSessions.length >= maxPinnedSessionsAllowed
        "
      >
        <div class="session-drawer-buttons">
          <button
            nf-icon-button="secondary"
            icon="close"
            class="btn-bare close"
            ngbTooltip="Close Session"
            (click)="deleteSession(session.id)"
            [loading]="deleteLoading && session.id === deleteSessionId"
          >
            Close Session
          </button>
          <button
            nf-icon-button="secondary"
            [icon]="session.isAffectedByJobRun ? 'reload-alert' : 'reload'"
            class="btn-bare reload"
            [ngClass]="{ 'text-danger': session.isAffectedByJobRun }"
            ngbTooltip="Refresh Session"
            [loading]="isRefreshingSession"
            (click)="refreshSession(session)"
            [disabled]="session.loadedAccountIds.length === 0"
            *ngIf="activeSessionId === session.id || expandedCards[session.id]"
          >
            Refresh Session
          </button>
        </div>
      </hs-session-card>
    </div>
    <small>
      Sessions will be automatically closed if the session has no commands or is
      not pinned.
    </small>
  </div>
</ng-container>
